import React from 'react'

import Experiment from '@mc/experiments-react'
import { usePromotion } from '@mc/promo-utils'
import { Locations } from '@mc/track-event'

import { GiftButton } from '../../components'
import { GLOBAL_CTAS_LPS_FLAG_NAME } from './constants'
import { useGiftEnabled, useTrackExperimentViewedFE } from '../../lib/helpers'

interface GlobalCtasLPsExperimentProps {
  children: React.ReactNode
  variant: (element: React.ReactNode) => JSX.Element
  location?: string
}

export const GlobalCtasLPsExperiment = ({
  children,
  variant,
  location = Locations.HERO,
}: GlobalCtasLPsExperimentProps) => {
  const { giftEnabled } = useGiftEnabled()
  const { isPromotionOn } = usePromotion()

  if (!giftEnabled || !isPromotionOn) return children

  return (
    <Content variant={variant} location={location}>
      {children}
    </Content>
  )
}

const Content = ({
  children,
  variant,
  location = Locations.HERO,
}: GlobalCtasLPsExperimentProps) => {
  useTrackExperimentViewedFE(GLOBAL_CTAS_LPS_FLAG_NAME)

  return (
    <Experiment
      name={GLOBAL_CTAS_LPS_FLAG_NAME}
      control={() => children}
      variant_1={() => {
        const giftButton = <GiftButton location={location} fullWidth />
        return variant(giftButton)
      }}
      track={true}
    />
  )
}
